// Re-Export-Hygiene: explizite Named-Imports/-Exports statt `export *`,
// damit Vite/Rollup beim SSR-Build kein "Ambiguous external namespace
// resolution" mehr meldet (mehrdeutige Re-Exports zwischen den
// three/examples/jsm-Modulen).
//
// FBX/GLTF/OBJLoader werden seit M2 (Plan-1.9-Phase-1-CP2) NICHT mehr
// statisch importiert. Sie werden von updateObject() in RendererWebGL.ts
// via dynamic import nur dann geladen, wenn ein object3d-Layer mit der
// entsprechenden extension instanziiert wird.

import * as three from 'three'

import { DDSLoader } from 'three/examples/jsm/loaders/DDSLoader.js'

import { CSS3DObject, CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer.js'
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

export {
  CSS3DObject,
  CSS3DRenderer,
  SVGLoader,
  OrbitControls,
}

new three.LoadingManager().addHandler(/\.dds$/i, new DDSLoader())

export default three
